import { SET_PENDING_DEEP_LINK, CLEAR_PENDING_DEEP_LINK } from '../actions/editListingDeepLink';

const defaultState = { pendingEditListingId: null };

export default function deepLink(state = defaultState, action) {
  switch (action.type) {
    case SET_PENDING_DEEP_LINK:
      return { ...state, pendingEditListingId: action.postingId };
    case CLEAR_PENDING_DEEP_LINK:
      return { ...state, pendingEditListingId: null };
    default:
      return state;
  }
}
